const ShadowEffect = () => (
  <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-black/10 to-transparent print:hidden"></div>
);

export default ShadowEffect;